<template>
  <div class="mxr-c-nav__cart">
    <img src="../assets/img/cart-icon.svg">
    <div class="mxr-c-nav__cart__bullet" v-if="cartSize > 0">{{cartSize}}</div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'cart',
    computed: {
      ...mapGetters(['cartSize']),
    },
  };
</script>

<style lang="scss">
  .mxr-c-nav {
    &__cart {
      &__bullet {
        background: $white;
        border-radius: 99em;
        height: rem-calc(19);
        min-width: rem-calc(19);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: rem-calc(11);
        color: $black;
        position: absolute;
        top: rem-calc(12);
        line-height: 0;
        padding: 0 rem-calc(5);
        right: 50%;
        transform: translateX(50%);
        margin-right: rem-calc(-14);
        font-weight: $global-weight-bold;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Cart.vue?fa1fcbd8